import { useState } from "react";
import { Link } from "react-router-dom";
import OwlCarousel from "react-owl-carousel-autoheight";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

const PropertyGallery = ({ img, id, index }) => {
  const [onLoad, setOnLoad] = useState(false);

  return (
    <Link
      className="property-img"
      target="_blank"
      to={`/property-details/${id}`}
    >
      {index === 4 && (
        <div className="info-msg">
          <p>Want to see more photos and details?</p>
          <h6>Open Property Details</h6>
        </div>
      )}
      <figure className={onLoad ? "" : "skeleton-loading"}>
        <img
          src={img}
          loading="lazy"
          onLoad={() => {
            setOnLoad(true);
          }}
          alt=""
        />
      </figure>
    </Link>
  );
};

const FeatureItem = ({ eachProperty }) => {
  const { property, images } = eachProperty;
  const {
    address,
    price_formatted,
    listingID,
    bedrooms,
    totalBaths,
    sqFt,
    remarksConcat,
  } = property;

  return (
    <div className="feature-item">
      <div className="feature-item-left">
        <OwlCarousel
          className="owl-carousel property-item-slider"
          nav={true}
          dots={true}
          margin={10}
          lazyLoad={true}
          items={1}
        >
          {images.map((eachImg, i) => (
            <PropertyGallery
              index={i}
              key={i}
              img={eachImg.full}
              id={listingID}
            />
          ))}
        </OwlCarousel>
      </div>
      <div className="feature-item-right">
        <h5 className={listingID !== null ? "" : "skeleton-loading"}>
          {address}
        </h5>
        <h4 className={listingID !== null ? "" : "skeleton-loading"}>
          {price_formatted} <span>(For Sale)</span>
        </h4>
        <h6>
          <span className={listingID !== null ? "" : "skeleton-loading"}>
            Listing ID: <span>{listingID}</span>
          </span>
          <a href=" " className={listingID !== null ? "" : "skeleton-loading"}>
            Add to Favorites
            <i className="fa fa-heart-o" aria-hidden="true"></i>
          </a>
        </h6>

        <div className="feature-bottom">
          <ul>
            <li className={listingID !== null ? "" : "skeleton-loading"}>
              <i className="fa fa-bed" aria-hidden="true"></i> {bedrooms}
            </li>
            <li className={listingID !== null ? "" : "skeleton-loading"}>
              <i className="fa fa-shower" aria-hidden="true"></i> {totalBaths}
            </li>
            <li className={listingID !== null ? "" : "skeleton-loading"}>
              <i className="fa fa-crop" aria-hidden="true"></i> {sqFt} SqFt
            </li>
          </ul>
        </div>
        <p
          className={listingID !== null ? "" : "skeleton-loading"}
          dangerouslySetInnerHTML={
            remarksConcat === null
              ? { __html: "" }
              : { __html: remarksConcat.slice(0, 200) + "..." }
          }
        />
        <Link
          target="_blank"
          to={`/property-details/${listingID}`}
          className={listingID !== null ? "btn" : "btn skeleton-loading"}
        >
          View Details
        </Link>
      </div>
    </div>
  );
};

export default FeatureItem;
